// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"ddf382c2","208":"4b639358","218":"ab57225e","242":"ec92136e","380":"b4067664","760":"31ec31cd","772":"2afb0a41","848":"5604aee2","898":"e75eb2ea","960":"746e9269","963":"bcc6812b"}[chunkId] + ".chunk.js";
};